import { Route, Switch } from 'react-router'

import { DealAssociations } from './pages/DealAssociations'
import { EditMasterPairing } from './pages/EditMasterPairing'
import { MasterPairings } from './pages/MasterPairings'
import React from 'react'

export const DealAssociationsRouter = () => (
  <Switch>
    <Route exact path={`/deal-associations`} component={DealAssociations} />
    <Route exact path={`/deal-associations/master-pairings`} component={MasterPairings} />
    <Route exact path={`/deal-associations/board/:boardId/device/:deviceId`} component={EditMasterPairing} />
  </Switch>
)
